<div [formGroup]="form" class="detail-right-column">
   @if (showCards) {
   <ndt-card [title]="'General Information'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="generalInfoFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half">
      <mat-label>Extension Number</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extension?.number"
         [formControl]="parentFormGroup.get('number')"
         required
         id="a548a982-17d2-4bee-9fa9-e2df166087e7"
      />
      @if (parentFormGroup.get('number')?.hasError('required')) {
      <mat-error> Number Field is Required. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('pattern')) {
      <mat-error> Invalid Number Format </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
      <mat-error> Number must be between 100-99999. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
      <mat-error> Extension number already in use. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.name"
         [formControl]="parentFormGroup.get('name')"
         required
         id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
      />
      @if (parentFormGroup.get('name')?.hasError('required')) {
      <mat-error> Name Field is Required. </mat-error>
      } @if ( !parentFormGroup.get('name')?.hasError('required') && parentFormGroup.get('name')?.hasError('noContent') )
      {
      <mat-error> Name must contain characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Short Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.shortName"
         [formControl]="parentFormGroup.get('shortName')"
         id="259c31c7-cb35-4577-b67f-5589b4a86a7c"
      />
      @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
      <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
      }
   </mat-form-field>
   }
   <ng-template #generalInfoFields>
      <mat-form-field class="flex-half">
         <mat-label>Extension Number</mat-label>
         <input
            matInput
            autocomplete="off"
            type="tel"
            [value]="extension?.number"
            [formControl]="parentFormGroup.get('number')"
            required
            id="a548a982-17d2-4bee-9fa9-e2df166087e7"
         />
         @if (parentFormGroup.get('number')?.hasError('required')) {
         <mat-error> Number Field is Required. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('pattern')) {
         <mat-error> Invalid Number Format </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
         <mat-error> Number must be between 100-99999. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
         <mat-error> Extension number already in use. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.name"
            [formControl]="parentFormGroup.get('name')"
            required
            id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
         />
         @if (parentFormGroup.get('name')?.hasError('required')) {
         <mat-error> Name Field is Required. </mat-error>
         } @if ( !parentFormGroup.get('name')?.hasError('required') &&
         parentFormGroup.get('name')?.hasError('noContent') ) {
         <mat-error> Name must contain characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Short Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.shortName"
            [formControl]="parentFormGroup.get('shortName')"
            id="259c31c7-cb35-4577-b67f-5589b4a86a7c"
         />
         @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
         <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
         }
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Notes'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="notesFields"></ng-container>
   </ndt-card>
   }
   <ng-template #notesFields>
      @if (isSystemUser) {
      <mat-form-field class="flex-half">
         <mat-label>Admin Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('adminNotes')"
            id="extension-phone-dnd-status"
         ></textarea>
      </mat-form-field>
      }
      <mat-form-field [ngClass]="{ 'flex-full': !isSystemUser, 'flex-half': isSystemUser }">
         <mat-label>Extension Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('extensionNotes')"
            id="extension-phone-dnd-status"
            [readonly]="isSystemUser"
         ></textarea>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Settings'" class="detail-card">
      <ng-container *ngTemplateOutlet="settingsFields"></ng-container>
   </ndt-card>
   } @else {
   <div class="flex-container flex-full">
      <mat-form-field class="flex-half">
         <mat-label>Phone Number to Call</mat-label>
         <input
            matInput
            autocomplete="off"
            type="tel"
            [value]="extensionExternalForward?.forwardToNumber"
            formControlName="forwardToNumber"
            id="extension-external-forward-forward-to-number"
            required
         />
         @if (form.get('forwardToNumber')?.hasError('required')) {
         <mat-error> Phone Number to Call Field is required. </mat-error>
         } @if (form.get('forwardToNumber')?.hasError('pattern')) {
         <mat-error>Please enter a valid phone number.</mat-error>
         }
      </mat-form-field>
      <mat-checkbox class="flex-half" formControlName="isPassthroughOriginalCallerId"
         >Send Originating Caller ID?</mat-checkbox
      >
   </div>
   @if (accountId) {
   <mat-form-field class="flex-half">
      <mat-label>Location</mat-label>
      <input
         autocomplete="off"
         type="text"
         [lcsSingleSelect]="locationSelect"
         ndtLocationSelect
         [accountId]="accountId"
         [formControl]="parentFormGroup.get('location')"
         id="location"
      />
      <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
   </mat-form-field>
   }
   <mat-form-field class="flex-half">
      <mat-label>Time Zone</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="timeZoneSelect"
         ndtTimeZoneSelect
         autocomplete="off"
         type="text"
         [formControl]="parentFormGroup.get('timeZone')"
         id="extension-phone-time-zone"
         [placeholder]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      />
      <ndt-time-zone-select
         #timeZoneSelect
         isIncludeEmptyOption="true"
         [overrideEmptyOption]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      ></ndt-time-zone-select>
   </mat-form-field>
   <mat-checkbox
      formControlName="isDtmf"
      class="flex-full"
      [checked]="form.get('isDtmf')?.value"
      (change)="onIsDtmfChange($event)"
      >Send DTMF?</mat-checkbox
   >
   @if (form.get('isDtmf')?.value) {
   <div class="flex-container flex-full">
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Seconds to pause before playing DTMF</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extensionExternalForward?.pauseSeconds"
            formControlName="pauseSeconds"
            id="extension-external-forward-pause-seconds"
         />
         @if (form.get('pauseSeconds')?.hasError('min') || form.get('pauseSeconds')?.hasError('max')) {
         <mat-error> Number must be between 0-25. </mat-error>
         } @else if (form.get('pauseSeconds')?.hasError('required')) {
         <mat-error>Seconds to pause before playing DTMF is required. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>DTMF to play</mat-label>
         <input
            matInput
            autocomplete="off"
            [value]="extensionExternalForward?.dtmf"
            formControlName="dtmf"
            id="extension-external-forward-dtmf"
         />
         @if (form.get('dtmf')?.hasError('maxlength')) {
         <mat-error>DTMF cannot exceed 25 characters.</mat-error>
         } @else if (form.get('dtmf')?.hasError('pattern')) {
         <mat-error>Invalid DTMF Format.</mat-error>
         } @else if (form.get('dtmf')?.hasError('required')) {
         <mat-error>DTMF to play is required. </mat-error>
         }
      </mat-form-field>
   </div>
   } }
   <ng-template #settingsFields>
      <div class="flex-container flex-full">
         <mat-form-field class="flex-half">
            <mat-label>Phone Number to Call</mat-label>
            <input
               matInput
               autocomplete="off"
               type="tel"
               [value]="extensionExternalForward?.forwardToNumber"
               formControlName="forwardToNumber"
               id="extension-external-forward-forward-to-number"
               required
            />
            @if (form.get('forwardToNumber')?.hasError('required')) {
            <mat-error> Phone Number to Call Field is required. </mat-error>
            } @if (form.get('forwardToNumber')?.hasError('pattern')) {
            <mat-error>Please enter a valid phone number.</mat-error>
            }
         </mat-form-field>
         <mat-checkbox class="flex-half" formControlName="isPassthroughOriginalCallerId"
            >Send Originating Caller ID?</mat-checkbox
         >
      </div>
      @if (accountId) {
      <mat-form-field class="flex-half">
         <mat-label>Location</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="locationSelect"
            ndtLocationSelect
            [accountId]="accountId"
            [formControl]="parentFormGroup.get('location')"
            id="location"
         />
         <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
      </mat-form-field>
      }
      <mat-form-field class="flex-half">
         <mat-label>Time Zone</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="timeZoneSelect"
            ndtTimeZoneSelect
            autocomplete="off"
            type="text"
            [formControl]="parentFormGroup.get('timeZone')"
            id="extension-phone-time-zone"
            [placeholder]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         />
         <ndt-time-zone-select
            #timeZoneSelect
            isIncludeEmptyOption="true"
            [overrideEmptyOption]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         ></ndt-time-zone-select>
      </mat-form-field>
      <mat-checkbox
         formControlName="isDtmf"
         class="flex-full"
         [checked]="form.get('isDtmf')?.value"
         (change)="onIsDtmfChange($event)"
         >Send DTMF?</mat-checkbox
      >
      @if (form.get('isDtmf')?.value) {
      <div class="flex-container flex-full">
         <mat-form-field class="flex-half field-padding-right">
            <mat-label>Seconds to pause before playing DTMF</mat-label>
            <input
               matInput
               autocomplete="off"
               type="number"
               [value]="extensionExternalForward?.pauseSeconds"
               formControlName="pauseSeconds"
               id="extension-external-forward-pause-seconds"
            />
            @if (form.get('pauseSeconds')?.hasError('min') || form.get('pauseSeconds')?.hasError('max')) {
            <mat-error> Number must be between 0-25. </mat-error>
            } @else if (form.get('pauseSeconds')?.hasError('required')) {
            <mat-error>Seconds to pause before playing DTMF is required. </mat-error>
            }
         </mat-form-field>
         <mat-form-field class="flex-half">
            <mat-label>DTMF to play</mat-label>
            <input
               matInput
               autocomplete="off"
               [value]="extensionExternalForward?.dtmf"
               formControlName="dtmf"
               id="extension-external-forward-dtmf"
            />
            @if (form.get('dtmf')?.hasError('maxlength')) {
            <mat-error>DTMF cannot exceed 25 characters.</mat-error>
            } @else if (form.get('dtmf')?.hasError('pattern')) {
            <mat-error>Invalid DTMF Format.</mat-error>
            } @else if (form.get('dtmf')?.hasError('required')) {
            <mat-error>DTMF to play is required. </mat-error>
            }
         </mat-form-field>
      </div>
      }
   </ng-template>
</div>
